// Where the "Back" button in the project nav should return to.
// Set before navigating to a project; defaults to /index.
import { ref } from 'vue'

const route = ref('/index')

export const backRoute = route
export const setBackRoute = (path) => { route.value = path }
